<div [formGroup]="form">
  <label class="form-field-label">{{ licenses?.name | titleCase }}</label>
  <mat-radio-group
    formControlName="submittedVariantId"
    class="d-flex flex-column"
    (change)="refreshLicenseForm($event.value)"
  >
    <mat-radio-button *ngFor="let item of licenses?.variants" [value]="item.id">
      {{ item.name | titleCase }}
    </mat-radio-button>
  </mat-radio-group>

  <div class="row mt-3">
    <div class="col-sm-4" *ngFor="let option of selectedVariant?.content">
      <mat-form-field2 class="mat-block" *ngIf="!option.possibleValues">
        <mat-label>{{ option?.name | titleCase }}</mat-label>
        <input
          matInput
          type="text"
          [formControlName]="option.name"
          [placeholder]="samples[option.name] || option?.name | titleCase"
          [required]="option.required"
        />
        <mat-error *ngIf="form.get(option.name).hasError('required')">
          {{ option.name | titleCase }} is required.
        </mat-error>
        <mat-error *ngIf="form.get(option.name).hasError('pattern')">
          {{ option.name | titleCase }} is invalid.
        </mat-error>
      </mat-form-field2>
      <mat-form-field2 class="mat-block" *ngIf="option.possibleValues">
        <mat-select
          [formControlName]="option.name"
          [placeholder]="option?.name | titleCase"
          [required]="option.required"
        >
          <mat-option *ngFor="let value of option.possibleValues" [value]="value">
            {{ value }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.get(option.name).hasError('required')">
          {{ option.name | titleCase }} is required.
        </mat-error>
      </mat-form-field2>
    </div>
  </div>
</div>
